// Тексты блога на трёх языках.
import type { BlogLang } from "@/lib/blog";

type Copy = {
  meta: { title: string; description: string };
  h1: string;
  lead: string;
  empty: string;
  prev: string;
  next: string;
  pageOf: (n: number, total: number) => string;
  by: string;
  ctaTitle: string;
  ctaAbroad: string;
  ctaTest: string;
  ctaTutors: string;
  /** Подпись блока статей на карточке коуча (/coaches). */
  coachArticles: string;
  /** Ссылка «Bloq / Блог / Blog» в подвале. */
  footer: string;
  /** Пилюля темы на обложке без картинки. */
  topic: { career: string; abroad: string };
  /** «5 dəq / 5 мин / 5 min». */
  readTime: (n: number) => string;
  /** Карточка коуча внизу статьи. */
  aboutAuthor: string;
  coachProfile: string;
};

export const BLOG_COPY: Record<BlogLang, Copy> = {
  az: {
    meta: {
      title: "Yolutap bloqu — karyera, təhsil və repetitorlar",
      description: "Yolutap və kouçlarımızın məqalələri: peşə seçimi, xaricdə təhsil, repetitor və dərnək seçimi haqqında.",
    },
    h1: "Bloq",
    lead: "Yolutap və kouçlarımızın məqalələri.",
    empty: "Hələ məqalə yoxdur.",
    prev: "← Əvvəlki",
    next: "Növbəti →",
    pageOf: (n, t) => `Səhifə ${n} / ${t}`,
    by: "Müəllif",
    ctaTitle: "Növbəti addım",
    ctaAbroad: "Xaricdə universitet seçimi — pulsuz",
    ctaTest: "Karyera testi",
    ctaTutors: "Repetitorlar və dərnəklər xəritəsi",
    coachArticles: "Məqalələri",
    footer: "Bloq",
    topic: { career: "Karyera", abroad: "Xaricdə təhsil" },
    readTime: (n) => `${n} dəq`,
    aboutAuthor: "Müəllif haqqında",
    coachProfile: "Kouçun profili →",
  },
  ru: {
    meta: {
      title: "Блог Yolutap — профессии, учёба и репетиторы",
      description: "Статьи Yolutap и наших коучей: выбор профессии, учёба за рубежом, как выбрать репетитора и кружок.",
    },
    h1: "Блог",
    lead: "Статьи Yolutap и наших коучей.",
    empty: "Статей пока нет.",
    prev: "← Назад",
    next: "Дальше →",
    pageOf: (n, t) => `Страница ${n} из ${t}`,
    by: "Автор",
    ctaTitle: "Что дальше",
    ctaAbroad: "Подбор вузов за рубежом — бесплатно",
    ctaTest: "Карьерный тест",
    ctaTutors: "Карта репетиторов и кружков",
    coachArticles: "Статьи",
    footer: "Блог",
    topic: { career: "Карьера", abroad: "Учёба за рубежом" },
    readTime: (n) => `${n} мин`,
    aboutAuthor: "Об авторе",
    coachProfile: "Профиль коуча →",
  },
  en: {
    meta: {
      title: "Yolutap blog — careers, study and tutors",
      description: "Articles from Yolutap and our coaches: choosing a career, studying abroad, finding a tutor or a club.",
    },
    h1: "Blog",
    lead: "Articles from Yolutap and our coaches.",
    empty: "No articles yet.",
    prev: "← Previous",
    next: "Next →",
    pageOf: (n, t) => `Page ${n} of ${t}`,
    by: "Author",
    ctaTitle: "Next step",
    ctaAbroad: "Free university match abroad",
    ctaTest: "Career test",
    ctaTutors: "Map of tutors and clubs",
    coachArticles: "Articles",
    footer: "Blog",
    topic: { career: "Career", abroad: "Study abroad" },
    readTime: (n) => `${n} min`,
    aboutAuthor: "About the author",
    coachProfile: "Coach profile →",
  },
};
